import { z } from 'zod';

export const exchangeForCodeBodySchema = z.object({
  code: z.string().optional(),
  iss: z.string().optional(),
  session_state: z.string().optional(),
  redirect_uri: z.string().optional(),
  code_verifier: z.string().optional(),
});

export type ExchangeForCodeBody = z.infer<typeof exchangeForCodeBodySchema>;
